import React, { useCallback, useMemo, useState } from "react";
import { Function0, Function1 } from "lodash";
import fp from "lodash/fp";
import { Modal, Row, Col } from "react-bootstrap";

import { CloseButton } from "components";
import { DealNote } from "types";

import { NoteForm } from "./noteForm";

import styles from "./notes.module.scss";

type NoteFormModalProps = {
	show: boolean;
	onHide: Function0<void>;
	title: string;
	note: DealNote;
	addNote: Function1<EditNote, Promise<void>>;
	editNote: Function1<EditNote, Promise<void>>;
	showDiff: boolean;
	brandingColor?: boolean;
	loading: boolean;
	isApplication: boolean;
	isDealNote?: boolean;
	isHideViewPrivatesNotes?: boolean;
	dealNotesCategories?: { [key: string]: any }[];
};

type EditNote = {
	note: string;
	title: string;
	entityId?: string;
	phase?: number;
	id?: string;
};

export const NoteFormModal = ({
	show,
	onHide,
	title: modalTitle,
	note,
	addNote,
	editNote,
	showDiff,
	brandingColor = false,
	loading,
	isHideViewPrivatesNotes = false,
	dealNotesCategories,
}: NoteFormModalProps) => {
	const isEdit = useMemo(() => !fp.isEmpty(note), [note]);
	const [isSubmitting, setIsSubmitting] = useState(false);

	const handleSave = useCallback(
		async values => {
			setIsSubmitting(true);
			try {
				if (isEdit) {
					await editNote(values);
				} else {
					await addNote(values);
				}
			} finally {
				setIsSubmitting(false);
				onHide();
			}
		},
		[addNote, editNote, isEdit, onHide],
	);

	return (
		<Modal
			show={show}
			onHide={onHide}
			animation={false}
			centered
			scrollable
			id="noteFormModal"
			className={styles.modalSizeFix}
		>
			<Modal.Header>
				<Modal.Title className="text-center">{modalTitle}</Modal.Title>
				<CloseButton onClick={onHide} />
			</Modal.Header>
			<Modal.Body style={{ maxHeight: "75vh" }}>
				<Row>
					<Col md={{ span: 8, offset: 2 }}>
						<NoteForm
							handleSave={handleSave}
							dealNote={note}
							showDiff={showDiff}
							loading={isSubmitting}
							brandingColor={brandingColor}
							isHideViewPrivatesNotes={isHideViewPrivatesNotes}
							dealNotesCategories={dealNotesCategories}
						/>
					</Col>
				</Row>
			</Modal.Body>
		</Modal>
	);
};
